// import axios from 'axios';
import apiCall from '../../../api';
import { get } from '../../api/api.service';
import { getItem } from '../../helper/localstorage.helper';
import { toast } from 'react-toastify';
import i18n from '../../../translation/i18n';

export interface ChatSearchParams {
  query: string;
}

export const fetchChatSearchApi = async (params: ChatSearchParams) => {
  const url = '/userdashboard/user-invoice-search';
  return await get(url, params);
};

export interface InvoicePdfParams {
  invoiceNumber: string;
  locale?: string;
}

export const downloadInvoicePdf = async (params: InvoicePdfParams): Promise<Blob> => {
  const url = '/invoice/invoice-pdf-client';
  const token = getItem('token');
  const t = i18n.t;
  toast.info(t('PREPARING_INVOICE_PDF_DOWNLOAD') as String, { autoClose: 2000 });

  try {
    const response = await apiCall.get(url, {
      params: {
        invoiceNumber: params.invoiceNumber,
        locale: params.locale || 'sv-se'
      },
      headers: {
        'Accept': 'application/pdf',
        'Authorization': token ? `Bearer ${token}` : '',
      },
      responseType: 'blob',
      withCredentials: true
    });
    if (response.status === 200) {
      toast.success(t('INVOICE_PDF_READY_FOR_DOWNLOAD') as String, { autoClose: 2000 });
    }

    return response.data as Blob;
  } catch (error: any) {
    console.error('Download invoice PDF error:', error);
    toast.error(t('FAILED_TO_DOWNLOAD_INVOICE_PDF') as String, { autoClose: 2000 });
    throw new Error(
      error.response?.data?.message ||
      error.message ||
      (t('FAILED_TO_DOWNLOAD_INVOICE_PDF') as String)
    );
  }
};


export const downloadDraftInvoicePdf = async (params: InvoicePdfParams): Promise<Blob> => {
  const url = '/draftinvoicev2/download-draft-invoice';
  const token = getItem('token');
  const t = i18n.t;
  toast.info(t('PREPARING_INVOICE_PDF_DOWNLOAD') as String, { autoClose: 2000 });

  try {
    const response = await apiCall.get(url, {
      params: {
        id: params.invoiceNumber,
        locale: params.locale || 'sv-se'
      },
      headers: {
        'Accept': 'application/pdf',
        'Authorization': token ? `Bearer ${token}` : '',
      },
      responseType: 'blob',
      withCredentials: true
    });
    if (response.status === 200) {
      toast.success(t('INVOICE_PDF_READY_FOR_DOWNLOAD') as String, { autoClose: 2000 });
    }

    return response.data as Blob;
  } catch (error: any) {
    console.error('Download invoice PDF error:', error);
    toast.error(t('FAILED_TO_DOWNLOAD_INVOICE_PDF') as String, { autoClose: 2000 });
    throw new Error(
      error.response?.data?.message ||
      error.message ||
      t('FAILED_TO_DOWNLOAD_INVOICE_PDF') as String
    );
  }
};

export const downloadSalarySlip = async (params: InvoicePdfParams, type: string): Promise<Blob> => {
  const url = '/salary/salary-slip-pdf';
  const token = getItem('token');
  const t = i18n.t;
  toast.info(t('PREPARING_INVOICE_PDF_DOWNLOAD') as String, { autoClose: 2000 });

  try {
    const response = await apiCall.get(url, {
      params: {
        id: params.invoiceNumber,
        locale: params.locale || 'sv-se',
        salaryType: type
      },
      headers: {
        'Accept': 'application/pdf',
        'Authorization': token ? `Bearer ${token}` : '',
      },
      responseType: 'blob',
      withCredentials: true
    });
    if (response.status === 200) {
      toast.success(t('INVOICE_PDF_READY_FOR_DOWNLOAD') as String, { autoClose: 2000 });
    }

    return response.data as Blob;
  } catch (error: any) {
    console.error('Download invoice PDF error:', error);
    toast.error(t('FAILED_TO_DOWNLOAD_INVOICE_PDF') as String, { autoClose: 2000 });
    throw new Error(
      error.response?.data?.message ||
      error.message ||
      (t('FAILED_TO_DOWNLOAD_INVOICE_PDF') as String)
    );
  }
};